import { AlertTriangle } from 'lucide-react';
import { dateCourte, type AvertissementDeLEcole } from '../../../lib/jpa/regles';

/*
  L'avertissement que l'équipe écrit en programmant une journée, en vue avant
  d'inscrire : à l'étape 1 sur la carte de l'école, à l'étape 2 au-dessus des
  enfants. Le même texte sur toutes les journées se dit une fois ; sinon, les
  dates qu'il concerne le précèdent.
*/

const majuscule = (t: string) => t.charAt(0).toUpperCase() + t.slice(1);

export default function AvertissementsDeLEcole({ avertissements }: { avertissements: AvertissementDeLEcole[] }) {
  if (avertissements.length === 0) return null;
  return (
    <span className="flex gap-2.5 rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950" role="note">
      <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" aria-hidden="true" />
      <span className="space-y-1">
        {avertissements.map((a) => (
          <span key={a.texte} className="block whitespace-pre-line">
            {a.dates && <strong className="font-bold">{majuscule(a.dates.map(dateCourte).join(', '))} : </strong>}
            {a.texte}
          </span>
        ))}
      </span>
    </span>
  );
}
